import { add, minus, unitPerp, scale } from './Geometry';

export default function WhiskerLine({
  x1,y1,x2,y2,
  whiskers,
  stroke,
  strokeWidth,
  whiskerLength
}){
  stroke = stroke || "blue";

  let lineVector = (minus([x2,y2],[x1,y1]))
    let whiskerDirection = unitPerp(lineVector);
    let whiskerLen = whiskerLength || 10;

    let halfWhiskerVector = scale(0.5*whiskerLen,whiskerDirection);
    let startWhiskerStart = add([x1,y1],halfWhiskerVector); 
    let startWhiskerEnd = minus([x1,y1],halfWhiskerVector);

    let endWhiskerStart = add([x2,y2],halfWhiskerVector);
    let endWhiskerEnd = minus([x2,y2],halfWhiskerVector);

    whiskers = [
      <line strokeWidth={1} stroke={stroke} x1={startWhiskerStart[0]} y1={startWhiskerStart[1]} x2={startWhiskerEnd[0]} y2={startWhiskerEnd[1]}/>,

      <line stroke={stroke} strokeWidth={1} x1={endWhiskerStart[0]} y1={endWhiskerStart[1]} x2={endWhiskerEnd[0]} y2={endWhiskerEnd[1]}/>

    ]

    return (
      <>
        <line {...{x1,y1,x2,y2,stroke, strokeWidth}}/>
        {whiskers}
      </>
    )
}
